import initializeForm from './initializeForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModalProduct from './toggleModalProduct';

export default (branchSelected) => (dispatch) => {
    const newValues = {
        branch_office:
            branchSelected !== 'all' && branchSelected !== 'company'
                ? branchSelected
                : '',
    };

    dispatch(setIsNewRecord(true));
    dispatch(initializeForm(newValues));
    dispatch(toggleModalProduct(true));
};
